export function gauge(ctx) {
    return {
        properties: {
            value_color: ctx.COLOR_BG_TEXT,  // #3b3e42
            value_font:  32,
        },
        styles: {
            main: {
                ...ctx.pretty,
                radius: 999,
                padding: 10,
                scale_width: 15,
                scale_border_width: 0,
                line_width: 5,
                line_color: '#888888',
                scale_grad_color: '#888888',
                scale_end_color: ctx.accent,
            },
            indicator: {
                bg_color: '#464b5b',   // IS_LIGHT gauge needle bg
                radius: 999,
                border_width: 0,
                line_color: '#464b5b',   // needle line color
                line_width: 4,
            },
            major_ticks: {
                scale_width: 25,
                line_width: 8,
                line_color: '#888888',
                scale_grad_color: '#888888',
                scale_end_color: ctx.accent,
            },
        },
    };
}
